import { useTranslation } from 'react-i18next'
import { observer } from 'mobx-react'

import {useMutation, useStore} from '../../../../../../utils/mst-hooks'
import './calendar-designation-filter.scss'
import { Multiselect } from '../../../../../../components/form/multiselect/multiselect'
import { TrackedEvent, trackingService } from '../../../../../../services/tracking-service'
import {useEffect} from "react";
import {getWeekDates} from "../../../../../../utils/datetime-utils";
import moment from "moment/moment";

function CalendarDesignationFilterComponent({
  designationIds,
  setDesignationIds,
  selectedDate,
  locationIds
}: {
  designationIds: number[]
  setDesignationIds: (values: number[]) => void
    selectedDate: Date
    locationIds: number[]
}) {
    moment.locale('en')

  const { t } = useTranslation()

  const { professionList, getProfessions } = useStore().data

    const [professionsQueryResult, professionsQuery] = useMutation(({ hasShiftsFrom, hasShiftsTo, hasShiftsAtLocationIds }: { hasShiftsFrom: string, hasShiftsTo: string, hasShiftsAtLocationIds: number[] }) => getProfessions({
        hasShiftsFrom,
        hasShiftsTo,
        hasShiftsAtLocationIds
    }))

    useEffect(() => {
        const weekDates = getWeekDates(selectedDate)
        const firstDayOfWeek = moment(weekDates[0]).format('YYYY-MM-DD')
        const lastDayOfWeek = moment(weekDates[weekDates.length - 1]).format('YYYY-MM-DD')

        professionsQuery({
            hasShiftsFrom: firstDayOfWeek,
            hasShiftsTo: lastDayOfWeek,
            hasShiftsAtLocationIds: locationIds
        })
    }, [selectedDate, locationIds]);

  const dataOptions =
    professionList.length > 0
      ? professionList.map(item => ({
          key: String(item.id),
          label: item.name,
          value: item.id,
        }))
      : []

  if (professionsQueryResult.isLoading) {
    return null
  }

  return (
    <div className="CalendarLocationFilter">
      <Multiselect
        options={dataOptions}
        className="CalendarLocationFilter__select"
        label={t('all_jobs.filter_designation')}
        onChange={values => {
          trackingService.track(TrackedEvent.TimesheetDesignationFilterUsed)
          setDesignationIds(values.map(value => Number(value)))
        }}
      />
    </div>
  )
}

export const CalendarDesignationFilter = observer(CalendarDesignationFilterComponent)
